<template>
  <span>
    <v-tooltip v-if="exists(label) && translate(label) !=='NA'" bottom max-width=300>
      <template v-slot:activator="{ on }">
        <span v-on="on">
          <v-icon data-test="icon" class="icon-color" small>mdi-help-circle</v-icon>
        </span>
      </template>

      <span data-test="help-content" class="first-letter-capital">{{ translate(label) }}</span>
    </v-tooltip>
  </span>
</template>

<script lang="ts">
import { Component, Mixins, Prop } from 'vue-property-decorator';
import { InternationalizedLabel } from '@/interfaces/InternationalizedLabel';
import TranslateMixin from '@/components/Mixins/TranslateMixin.vue';

@Component
export default class HelpTooltip extends Mixins(TranslateMixin) {
  @Prop({ type: [Object, String], required: true })
  public readonly label!: InternationalizedLabel;
}
</script>

<style lang="scss" scoped>
@import '@/main.scss';

.icon-color {
  color: $blue;
}
</style>
